import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-secondary text-white/80 mt-20">
      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center font-display font-extrabold text-white">L</div>
            <span className="font-display font-bold text-white">LesMeilleursPrix</span>
          </div>
          <p className="text-sm text-white/60">Comparez les prix, trouvez les bons plans et réservez vos prestataires — partout en Afrique francophone.</p>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3 text-sm">Découvrir</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/recherche" className="hover:text-primary">Comparer les prix</Link></li>
            <li><Link to="/promotions" className="hover:text-primary">Promotions</Link></li>
            <li><Link to="/prestataires" className="hover:text-primary">Prestataires</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3 text-sm">Professionnels</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/register" className="hover:text-primary">Devenir commerçant</Link></li>
            <li><Link to="/register" className="hover:text-primary">Devenir prestataire</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3 text-sm">Paiement</h4>
          <p className="text-sm text-white/60">Orange Money · MTN MoMo · Wave · Moov · Carte</p>
        </div>
      </div>
      <div className="border-t border-white/10 py-4 text-center text-xs text-white/40">© 2026 LesMeilleursPrix. Tous droits réservés.</div>
    </footer>
  );
}
